import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-15598f40"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "page-box"
};
const _hoisted_2 = {
  class: "content-box"
};
const _hoisted_3 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "universalRound",
  style: {
    "bottom": "-300px",
    "left": "-1400px",
    "z-index": "1",
    "width": "1800px",
    "height": "1600px",
    "background-size": "100% 100%"
  }
}, null, -1));
const _hoisted_5 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "universalRound",
  style: {
    "bottom": "-450px",
    "right": "-1400px",
    "z-index": "1",
    "width": "1800px",
    "height": "1600px",
    "background-size": "100% 100%"
  }
}, null, -1));
const _hoisted_7 = {
  style: {
    "position": "relative"
  }
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "universalRound",
  style: {
    "bottom": "-250px",
    "left": "-1500px",
    "z-index": "1",
    "width": "1600px",
    "height": "1400px",
    "background-size": "100% 100%"
  }
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_header_com = _resolveComponent("header-com");
  const _component_module_head_com = _resolveComponent("module-head-com");
  const _component_product_info = _resolveComponent("product-info");
  const _component_product_features = _resolveComponent("product-features");
  const _component_advantage_com = _resolveComponent("advantage-com");
  const _component_apply_com = _resolveComponent("apply-com");
  const _component_footer_com = _resolveComponent("footer-com");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_header_com), _createVNode(_component_module_head_com, {
    title: "无垠协议模糊测试智能体",
    tips: "为协议应用的安全性与健壮性赋能",
    buttomName: "立即体验",
    ngUrl: _ctx.BG
  }, null, 8, ["ngUrl"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_product_info), _hoisted_4]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_product_features, {
    ref: "ProductFeatures"
  }, null, 512), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_advantage_com, {
    ref: "AdvantageCom"
  }, null, 512), _hoisted_8])]), _createVNode(_component_apply_com, {
    ref: "ApplyCom"
  }, null, 512), _createVNode(_component_footer_com)]);
}